import { all } from 'redux-saga/effects';
import users from './user.saga';

export default function* sagas() {
  yield all([
    ...users,
  ]);
}